import { render, staticRenderFns } from "./CenterOffer.vue?vue&type=template&id=5eb12bb7&"
import script from "./CenterOffer.vue?vue&type=script&lang=js&"
export * from "./CenterOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports